
  
// Script Généré le : 10/01/2026 10:38:10 via ModelGenerator.nt
//  IntUserUpdateParameters.ts
// Chemin de sortie : ..\..\..\front-shared\paf-shared\projects\ngx-paf-common\src\lib\Models\IntUserUpdateParameters.ts

import {IntUser } from "./IntUser";
import {IntUserStatutHistory } from "./IntUserStatutHistory";
import {PS_PAFX_DR_Result } from "./PS_PAFX_DR_Result";
export class IntUserUpdateParameters {

  // IntUser IntUser
  public IntUser: IntUser=null;

  // bool? StatutOnly
  public StatutOnly?: boolean=null;

  // IntUserStatutHistory IntUserStatutHistory
  public IntUserStatutHistory: IntUserStatutHistory=null;

  // PS_PAFX_DR_Result[] Etbs
  public Etbs: PS_PAFX_DR_Result[]=[];
}